import React from 'react';

const Footer = () => {
    return (
        <footer>
            <p>&copy; 2022 developed + designed by Heather Voisin</p>
        </footer>
    )
}

export default Footer;